import { AiComponentData, CollapseData, collapseDataSchema } from "../../types/AiComponent";
import { AlertCircle, AlertTriangle, Info } from "lucide-react";
import remarkGfm from "remark-gfm";
import ReactMarkdown from "react-markdown";
import { BlockMatch } from "../../../lib/llm-ui";
import { parseJson5 } from "../../../lib/json5";

export function CollapseBlock({ blockMatch }: { blockMatch: BlockMatch }) {
  if (!blockMatch.isVisible) {
    return null;
  }

  const { data, error } = collapseDataSchema.safeParse(parseJson5(blockMatch.output));

  if (error) {
    console.error(error);
    return null;
  }

  return <Collapse {...data} />;
}

export function Collapse({ title, content, level }: AiComponentData<CollapseData>) {
  return (
    <div tabIndex={0} className="collapse collapse-arrow bg-white border-base-300 border">
      <div className="collapse-title font-semibold flex items-center gap-2">
        {level ? <CollapseIcon level={level} /> : null}
        <span>{title}</span>
      </div>
      <div className="collapse-content text-sm">
        {content ? (
          <div className="prose max-w-none">
            <ReactMarkdown remarkPlugins={[remarkGfm]}>{content}</ReactMarkdown>
          </div>
        ) : null}
      </div>
    </div>
  );
}

function CollapseIcon({ level }: { level: "info" | "warning" | "error" }) {
  switch (level) {
    case "info":
      return <Info className="w-5 h-5 text-info flex-none" />;
    case "warning":
      return <AlertCircle className="w-5 h-5 text-warning flex-none" />;
    case "error":
      return <AlertTriangle className="w-5 h-5 text-error flex-none" />;
  }
}
